// extracted by mini-css-extract-plugin
export default {"cancelButton":"confirm_popup_cancelButton__mJO8R","confirm_dialog":"confirm_popup_confirm_dialog__1vl6Z","confirmButton":"confirm_popup_confirmButton__L-b19"};